import React from "react";

import { UpdatePassword } from "features/user/updatePassword";
import { useMasterListState } from "features/masterList/masterListProvider";

const iconProps = {
  width: 18,
  height: 18,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

const UserIcon = () => (
  <svg {...iconProps}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-4 3.5-6 8-6s8 2 8 6" />
  </svg>
);

const MailIcon = () => (
  <svg {...iconProps}>
    <rect width="20" height="16" x="2" y="4" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);

const PhoneIcon = () => (
  <svg {...iconProps}>
    <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
  </svg>
);

const ProfileDetailRow = ({ icon, label, value }) => (
  <div className="profile-detail-row">
    <span className="profile-detail-row__icon">{icon}</span>
    <div className="profile-detail-row__text">
      <span className="profile-detail-row__label">{label}</span>
      <span className="profile-detail-row__value">{value}</span>
    </div>
  </div>
);

export const UserProfile = (props) => {
  const masterList = useMasterListState();
  const user = masterList["user"];

  return (
    <div className="container">
      <div className="card mx-2 my-2">
        <header className="card-header">
          <span className="card-header-title">
            <h5 className="is-size-5">User Details</h5>
          </span>
        </header>
        <div className="card-content">
          <div className="content">
            <ProfileDetailRow
              icon={<UserIcon />}
              label="User Name"
              value={user.name}
            />
            <ProfileDetailRow
              icon={<MailIcon />}
              label="Email"
              value={user.email}
            />
            <ProfileDetailRow
              icon={<PhoneIcon />}
              label="Contact"
              value={user.contactNo}
            />
          </div>
        </div>
        {/* /.card-content */}
      </div>
      {/* /.card */}
      <UpdatePassword {...props} />
    </div>
  );
};
